<template>
 <div>
   <!-- we set delay and touch-start-threshold to try to give a better experience on mobile -->
   <draggable
     delay = 30
     delay-on-touch-only = true
     touch-start-threshold=5
     handle = '.rm-task-handle'
     :list="tasks"
     :disabled="readonly"
     class="tasks-group"
     ghost-class="ghost"
     @start="dragging = true"
     @end="dragging = false"
     ref=tasks
     >
     <task
       v-for="(task, idx) in tasks"
       :key="task.id"
       :task="task"
       :fieldPermissions="permissions"
       :i18n="i18n"
       :readonly="readonly"
       :debug="debug"
       :usermBaseUrl="usermBaseUrl"
       @editTask="onEdit(idx)"
       @deleteTask="remove(idx)" ></task>
  </draggable>
  <i class="clickable icon-plus-sign text-green"
     v-if="!readonly && permissions.CREATE"
     @click="add"></i>
  <div v-if="debug">
    <div v-for="dTask in tasks" :key="dTask.id">{{ dTask }}</div>
  </div>
 </div>
</template>

<script>
import Task from './task.vue'
import draggable from 'vuedraggable';

var fakeIds = 0;

export default {
  components: { draggable, Task },

  model: {
    prop: 'tasks',
    event: 'change'
  },

  props: {
    tasks: Array,
    permissions: { type: Object, default: () => ({}) },
    debug: { type: Boolean, default: false},
    readonly: { type: Boolean, default: false},
    usermBaseUrl:String,
    i18n: Object
  },

  data () {
      return {
          showUserSearch : false
      }
  },

  created() {
    fakeIds = Math.max(...this.tasks.map((t) => t.id))
  },

  methods: {

    add: function(){
      this.tasks.push({
        id: ++fakeIds,
        name: '',
        state: 'TODO',
        editing: true,
        permissions: {
          COMPLETE: true,
          DELETE: true,
          ASSIGN: true,
          SCHEDULE: true
        }
      });
    },

    onEdit: function(idx){
      window.console.debug('TASKS', 'onEdit', idx);
      this.tasks.filter((t, i) => i !== idx && t.editing).forEach((t) => t.editing =  false);
    },

    remove: function(idx){
      window.console.debug('TASKS', 'remove', idx);
      this.tasks.splice(idx, 1);
    }
  }
}
</script>

<style>
</style>

<!-- vim: set sw=2 ts=2 et : -->
